import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import '../css/SimSummaryTable.css';

const getTodayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const toDateTimePayload = (dateValue) => `${dateValue}T00:00:00`;

const getGroupRowClassName = (groupname) => {
  const normalizedGroupName = String(groupname ?? '').trim();

  if (normalizedGroupName === '1') return 'group-row-1';
  if (normalizedGroupName === '2') return 'group-row-2';
  if (normalizedGroupName === '3') return 'group-row-3';
  if (normalizedGroupName === '4') return 'group-row-4';
  if (normalizedGroupName === '5') return 'group-row-5';
  if (normalizedGroupName === '6') return 'group-row-6';
  if (normalizedGroupName === '7') return 'group-row-7';
  if (normalizedGroupName === '8') return 'group-row-8';
  if (normalizedGroupName === '9') return 'group-row-9';
  if (normalizedGroupName === '10') return 'group-row-10';
  if (normalizedGroupName === '11') return 'group-row-11';
  if (normalizedGroupName === '12') return 'group-row-12';

  return '';
};


function PlayerBalance() {  
  const [loading, setLoading] = useState(false);    

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [Result, setResult] = useState([]);
  const [selectedDate, setSelectedDate] = useState(getTodayDate());

  // handle button click of login form
  const HandleSimulate = useCallback((dateValue) => {
    setSuccess(null);
    setError(null);
    setLoading(true);        

    axios.get(process.env.REACT_APP_BACKEND_ADDRESS + '/rpt/getallplayers', {
      params: {
        createdat: toDateTimePayload(dateValue),
      },
    }).then(response => {
        setLoading(false);               
                    
         if (response.data.description === 'ok'){                              
          setResult(response.data.data)            
        }
        else {setError(response.data.description);}    

    }).catch(error => {      
       setLoading(false);
       setError(error?.response?.data?.description || error?.message || 'error calling');                
    });    
  }, []);
 
  //Page Load OnClick
  useEffect(() => {         
    HandleSimulate(getTodayDate());
    //document.getElementById("btnSimulate").click();
  }, [HandleSimulate]);

  const toAmount = (value) => {
    const amount = Number.parseFloat(value);
    return Number.isFinite(amount) ? amount : 0;
  };

  const formatAmount = (value) =>
    toAmount(value).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const totalStartBalance = Result.reduce((sum, tx) => sum + toAmount(tx.startbalance), 0);
  const totalEndBalance = Result.reduce((sum, tx) => sum + toAmount(tx.endbalance), 0);

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <input
          type="date"
          value={selectedDate}
          onChange={(event) => setSelectedDate(event.target.value)}
        />
        <input
          type="button"
          value={loading ? 'Loading...' : 'Search'}
          onClick={() => HandleSimulate(selectedDate)}
          disabled={loading}
          style={{ marginLeft: '8px' }}
        />
      </div>

      <div className="table-wrap">
        <table className="sim-table sim-history-table">
          <thead>
            <tr>
              <th className="game-head">No</th>
              <th className="game-head">PlayerID</th>
              <th className="game-head">PlayerName</th>
              <th className="game-head">Start Balance</th>
              <th className="game-head">End Balance</th>
              <th className="game-head">Updated At</th>
            </tr>
          </thead>
          <tbody>
            {Result.map((tx, index) => (
              <tr
                key={`${tx.playerid || 'player'}-${index}`}
                className={getGroupRowClassName(tx.groupname)}
              >
                <td>{index + 1}</td>
                <td>{tx.playerid}</td>
                <td>{tx.playername}</td>
                <td>
                  {formatAmount(tx.startbalance)}
                </td>
                <td>
                  {formatAmount(tx.endbalance)}
                </td>
                <td>
                  {tx.updatedAt ? new Date(tx.updatedAt).toLocaleString() : ''}
                </td>
              </tr>
            ))}
            <tr className="summary-row">
              <td></td>
              <td></td>
              <td>Total</td>
              <td>{formatAmount(totalStartBalance)}</td>
              <td>{formatAmount(totalEndBalance)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      {loading && <><small>Loading...</small><br /></>}<br />
      {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />
      {success && <><small style={{ color: 'green' }}>{success}</small><br /></>}<br />
        
    </div>
  );
}

export default PlayerBalance;